import { colord } from 'colord'

export const hexToRgba = (hex: string, alpha = 1): string => colord(hex).alpha(alpha).toRgbString()
